import { render, staticRenderFns } from "./createStd.vue?vue&type=template&id=c25f18aa&scoped=true&"
import script from "./createStd.vue?vue&type=script&lang=js&"
export * from "./createStd.vue?vue&type=script&lang=js&"
import style0 from "./createStd.vue?vue&type=style&index=0&id=c25f18aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25f18aa",
  null
  
)

export default component.exports